<template>
  <div class="page_wrapper container-fluid career_counselling_area">
    <div class="row page_header career_counselling_header">
      <career-counselling-header
        :title-ch="'業師諮詢'"
        :title-en="'Industry Counselling'"
      />
    </div>
    <div class="row career_counselling_content">
      <career-counselling-index-content
        :career-counselors-type="'業師'"
        :title-ch="'業師諮詢'"
        :title-en="'Industry Counselling'"
      />
    </div>
  </div>
</template>
<script>
import CareerCounsellingHeader from '~components/pages/career-counselling/CareerCounsellingHeader'
import CareerCounsellingIndexContent from '~components/pages/career-counselling/CareerCounsellingIndexContent'
import '~style/pages/career_counselling.scss'
export default {
  name: 'CareerCounsellingIndustryMentorIndex',
  routerName: 'Career-counsellingIndustry-mentors',
  components: {
    CareerCounsellingHeader,
    CareerCounsellingIndexContent
  }
}
</script>
